<template>
	<div>
		<div class="mian" v-loading="loading">
			<div class="searchbox fcs">
				<input type="text" placeholder="请输入搜索内容" v-model="search" />
				<div class="btn fcc" @click="searchbtn">搜索</div>
			</div>
			<div class="list fcs" v-for="(item,index) in list" :key="index" @click="godetails(item.id)">
				<div class="title">{{item.title}}</div>
				<div class="time">{{item.createtime}}</div>
			</div>
			<div class="fcc" style="margin: 50px 0;">
				<el-pagination background layout="prev, pager, next" :page-size="20" :total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				page: 1,
				search: '',
				list: [],
				total: 0
			}
		},
		created() {
			this.getlist();
		},
		methods: {
			//点击分页
			handleCurrentChange(val) {
				this.page = val;
				this.list = [];
				this.getlist();
			},
			searchbtn() {
				this.page = 1;
				this.list = [];
				this.getlist();
			},
			//获取招标公告
			getlist() {
				let data = {
					page: this.page,
					limit: 20,
					search: this.search
				}
				this.loading = true;
				this.$api.home.notice(data).then(res => {
					if (res.code == 1) {
						this.list = res.data.list;
						this.total = res.data.total;
					}
					this.loading = false;
				})
			},
			//跳转详情
			godetails(id) {
				this.$api.home.noticeinfo({
					notice_id: id
				}).then(res => {
					if (res.code == 1) {
						this.$router.push({
							path: '/details',
							query: {
								id: id
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 50px auto;
	}

	.mian .searchbox {
		width: 800px;
		height: 60px;
		background: #f5f5f5;
		margin: 50px auto;
		border-radius: 50px;
		box-sizing: border-box;
		padding: 0 20px;
	}

	.mian .searchbox input {
		width: 550px;
		height: 50px;
		outline: none;
		border: 0;
		background: #f5f5f5;
		font-size: 16px;
	}

	.mian .searchbox .btn {
		width: 120px;
		height: 44px;
		background: #0057A8;
		color: #ffffff;
		font-size: 16px;
		opacity: 0.9;
		border-radius: 100px;
		cursor: pointer;
	}

	.mian .list {
		width: 1000px;
		height: 54px;
		margin: 0 auto;
		border-bottom: #ADADAD dashed 1px;
		cursor: pointer;
	}

	.mian .list:hover {
		color: #0B457A;
		font-weight: bold;
	}

	.mian .list:hover .time {
		color: #0B457A;
	}

	.mian .list .title {
		width: 750px;
		font-size: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.mian .list .time {
		font-size: 16px;
		color: #333333;
	}
</style>